import { render, staticRenderFns } from "./PriceAnalysisTerms.vue?vue&type=template&id=23bc1192&scoped=true&"
import script from "./PriceAnalysisTerms.vue?vue&type=script&lang=js&"
export * from "./PriceAnalysisTerms.vue?vue&type=script&lang=js&"
import style0 from "./PriceAnalysisTerms.vue?vue&type=style&index=0&id=23bc1192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc1192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSwitch,VTextField})
